import React from "react";
import {
  Row,
  Col,
  Button} from "reactstrap";
// import logo from "assets/img/logo/logo_aig_login-2.png";
// import LoadingScreen from "react-loading-screen";
import Page from "components/Page";
import ValoresCotizacion from "../../../components/CotizacionFinanciero/CotizacionResponsabilidad/ValoresCotizacionResponsabilidad";
import ListadoProducto from "../../../components/CotizacionFinanciero/CotizacionResponsabilidad/ListadoProductoResponsabilidad";
import { withRouter, history } from "react-router-dom";
import { connect } from "react-redux";
import {encriptarTramaAES} from "../../../utils/Encriptar/index";
import {fetchConsultarCarritoResponsabilidad,fetchGuardarCarritoResponsabilidad } from "../../../redux/actions/aRamoLineaFinanciera";
import logo from "assets/img/logo/logo_aig_login-2.png";
import LoadingScreen from "react-loading-screen";
import {fetchEnviarPDFFinanciero} from "../../../redux/actions/aRamoLineaFinanciera";

class ContainerCotizacionResponsabilidad2 extends React.Component {
  constructor(props) {
    super(props);
    const queryParams = new URLSearchParams(this.props.location.search);

    this.state = {
      idCarrito : queryParams.get('id') !== null ? queryParams.get('id') : this.props.respuestaCarrito.respuestaGuardarResponsabilidad.idCarrito,
      arrayValidaciones:{
        formEditado :false,
        desabilitarBotonContinuar:true,
        arraySelects :''
      }
    }
  }

  async componentDidMount() {
    
    const {idCarrito} = this.state;

    const datosJSON ={
      idCarrito: idCarrito
    }
    const encriptado = await encriptarTramaAES(JSON.stringify(datosJSON));
    await this.props.consultarCarrito(Buffer.from(JSON.stringify(encriptado)).toString('base64'));  

  }

  onClickActualizarSelect = params => {
    const {formEditado,botonContinuar,arraySelects} = params;
    this.setState(prevState => ({ arrayValidaciones: { ...prevState.arrayValidaciones, formEditado: formEditado, 
      desabilitarBotonContinuar:botonContinuar,arraySelects: arraySelects}}))
  }

  onClickActualizarValores = async (params) => { 
    const {formEditado} = params;
    const {arrayValidaciones,idCarrito} = this.state;
    const {arraySelects} = arrayValidaciones;

    const datosJSON = {
      paso:"2",
      idCarrito: idCarrito,
      deducible : {codigo:arraySelects.deducible.codigo,
                  tasa:arraySelects.deducible.tasa,
                  valor:arraySelects.deducible.valor,
                  descripcion:arraySelects.deducible.name},
      perdidaDocumentos : {codigoAmparo:arraySelects.ampPerdida.id,
                  valor:arraySelects.ampPerdida.valor,
                  codigo:arraySelects.ampPerdida.posicion,
                  descripcion:arraySelects.ampPerdida.name},    
      infidelidadTerceros : {codigoAmparo:arraySelects.ampInfidelidad.id,
                  valor:arraySelects.ampInfidelidad.valor,
                  codigo:arraySelects.ampInfidelidad.posicion,
                  descripcion:arraySelects.ampInfidelidad.name},
      limite : {codOpcion:arraySelects.limite.codOpcion}
    }

    const encriptado = await encriptarTramaAES(JSON.stringify(datosJSON));
    //await this.props.guardarCarrito({"Data": Buffer.from(JSON.stringify(encriptado)).toString('base64')});  
    await this.props.guardarCarrito({"Data": Buffer.from(JSON.stringify(encriptado)).toString('base64'), "areaCotizador":this.props.detalleCarrito.datosCarritoResponsabilidad.carAreaCotizador});     

    const datosJSONC ={
      idCarrito: idCarrito
    }
    const encriptadoC = await encriptarTramaAES(JSON.stringify(datosJSONC));
    await this.props.consultarCarrito(Buffer.from(JSON.stringify(encriptadoC)).toString('base64'));  


    // if(this.props.respuestaCarrito.respuestaGuardarResponsabilidad.transaccion === true){
    //   this.props.history.push({
    //     pathname: "/resumen-cotizacion-responsabilidad"
    //   });
    // } else {
    //   this.setState({ 
    //     valAlerta: true,
    //     idCarrito : this.props.respuestaCarrito.respuestaGuardarResponsabilidad.idCarrito
    //   });
    // }

    this.setState(prevState => ({ arrayValidaciones: { ...prevState.arrayValidaciones, formEditado: formEditado}}))
  }
  onClickEnviarPDF = async params => {
    const {correo,idCarrito} = params;

    const datosJSON = {
      idCarrito: idCarrito,
      correo: correo
      }

    const encriptado = await encriptarTramaAES(JSON.stringify(datosJSON));
    await this.props.setCorreo(Buffer.from(JSON.stringify(encriptado)).toString('base64'));  
  }

  // regresa al anterior paso en el cotizador
  onClickRegresar = async params => {
    const pathBase = '/cotizacion-responsabilidad?idProducto=';
    const pathEmp = pathBase + '122';
    const pathInst = pathBase + '123';
    window.location.href = params === 'empresa'? pathEmp: pathInst;
    // this.props.history.push({
    //   pathname: ,
    // });
  }

  textosCargando() {
    if (this.props.respuestaCarrito.guardarCarritoResponsabilidadIsLoading)
    return "Guardando información. Por favor espere..."
    if (this.props.detalleCarrito.consultarCarritoResponsabilidadIsLoading)
      return "Obteniendo datos de resumen..."
    if (this.props.datosEnviarPDFFinanciero.enviarPDFFinancieroIsLoading )
      return "Enviando Cotización al Cliente..."
  }
  render() {
    const { arrayValidaciones} = this.state;
    const {detalleCarrito, datosEnviarPDFFinanciero,respuestaCarrito} = this.props;

    return (
      <main className="bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
          <LoadingScreen
                loading={detalleCarrito.consultarCarritoResponsabilidadIsLoading ||datosEnviarPDFFinanciero.enviarPDFFinancieroIsLoading || respuestaCarrito.guardarCarritoResponsabilidadIsLoading }
                bgColor="#f1f1f1"
                spinnerColor="#001871"
                textColor="#676767"
                logoSrc={logo}
                text={this.textosCargando()}
          >
            <Page
            title={detalleCarrito.datosCarritoResponsabilidad.carDescripcionSeguro}
            breadcrumbs={[{ name: detalleCarrito.datosCarritoResponsabilidad.carDescripcionSeguro, active: true }]}
            >
              <Row>
                <Col lg={8} md={12} sm={12} xs={12}>
                  <div className="container-step">
                    <div className="wrapper-step">
                      <div className="arrow-steps clearfix-step">
                        <div className="step"> {` 1. Cotización `} </div>
                        <div className="step current"> {` 2. Resumen `} </div>
                        <div className="step"> {` 3. Confirmación `} </div>
                        <div class="step"> {` 4. Forma de Pago `} </div>
                <div class="step"> {` 5. Formulario de Vinculación `} </div>
                <div class="step"> {` 6. Emisión `} </div>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
              {Object.keys(detalleCarrito.datosCarritoResponsabilidad).length > 0 &&
              <Row>
                <Col lg={8} md={12} sm={12} xs={12} className="detalle-cotizacion-box">
                  <ListadoProducto  onClickAtras={this.onClickRegresar} detalleCarrito={detalleCarrito.datosCarritoResponsabilidad} metodoActualizarSelect={this.onClickActualizarSelect}/>
                </Col>  
                <Col lg={4} md={12} sm={12} xs={12} className="detalle-impuestos-box">
                  <ValoresCotizacion paso={"resumen-cotizacion"} metodoActualizarValores={this.onClickActualizarValores} formActualizar={arrayValidaciones} 
                  detalleCarrito={detalleCarrito.datosCarritoResponsabilidad} metodoEnviar={this.onClickEnviarPDF}  />                  
                </Col>
              </Row> 
              }       
            </Page>
          </LoadingScreen>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => ({  
  respuestaCarrito : state.datosCotizacionResponsabilidad,
  detalleCarrito : state.datosCarritoResponsabilidad,
  datosEnviarPDFFinanciero: state.datosEnviarPDFFinanciero,
});

const mapDispatchToProps = dispatch => {
  return {  
    consultarCarrito: (data) => dispatch(fetchConsultarCarritoResponsabilidad(data)),
    guardarCarrito: data => dispatch(fetchGuardarCarritoResponsabilidad(data)),
    setCorreo: data => dispatch(fetchEnviarPDFFinanciero(data))
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContainerCotizacionResponsabilidad2)
);
